import React from "react";
import NavTop from "../../component/NavTop";
import NumberFormat from "react-number-format";
import { IoIosArrowForward } from "react-icons/io";
import { FormatDate } from "../../helpers";
import { cashflowUpdate, getTags } from "../../api";
import ButtonLoading from "../../component/ButtonLoading";
import FileUpload from "../../component/FileUpload";
import CreatableSelect from "react-select/creatable";

export default (props) => {
  const data = JSON.parse(localStorage.getItem("cashflow")) || {};
  const walletSearch =
    JSON.parse(localStorage.getItem("walletSearch")) || data.wallet;
  const currentTags = data.tags.map((t) => ({ label: t.tag, value: t.tag }));
  const [amount, setAmount] = React.useState(data.amount);
  const [date, setDate] = React.useState(FormatDate(data.date, "YYYY-MM-DD"));
  const [description, setDescription] = React.useState(data.description);
  const [selectedTags] = React.useState(currentTags);
  const [tags, setTags] = React.useState([]);
  const [tagNames, setTagNames] = React.useState(
    currentTags.map((t) => t.value)
  );
  const selectWallet = (e) => {
    props.history.push(
      "/wallet/search/" + data.wallet.id + "/walletSearch/notall"
    );
  };
  const [loading, setLoading] = React.useState(false);
  const [attachmentUrl, setAttachmentUrl] = React.useState(
    data.attachmentUrl || null
  );
  const handleSelectChange = (newValue, actionMeta) => {
    const names = newValue ? newValue.map((v) => v.value) : [];
    setTagNames(names);
  };
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const now = new Date();
    let a = new Date(date);
    a.setHours(now.getHours());
    a.setMinutes(now.getMinutes());
    a.setSeconds(now.getSeconds());
    const id = data.id;
    const wallet = { ...walletSearch };
    try {
      const apiData = {
        id,
        amount,
        description,
        date: a,
        tags: tagNames,
        walletId: wallet.id,
        attachmentUrl,
      };
      await cashflowUpdate(apiData);
      try {
        const cached = JSON.parse(localStorage.getItem("trx_data") || "[]");
        if (Array.isArray(cached)) {
          const idx = cached.findIndex((t) => t.id === id);
          if (idx >= 0) {
            cached[idx] = {
              ...cached[idx],
              amount,
              description,
              date: a.toISOString().slice(0, 19),
              wallet: { id: wallet.id, name: wallet.name },
              tags: tagNames.map((tag) => ({ cashflowId: id, tag })),
              attachmentUrl,
            };
            cached.sort((x, y) => (y.date || "").localeCompare(x.date || ""));
            localStorage.setItem("trx_data", JSON.stringify(cached));
            localStorage.setItem("trx_data_lastUpdate", String(Date.now()));
          }
        }
      } catch (_) {}
      localStorage.setItem("trx_focusId", id);
      window.history.back();
    } catch (err) {}
    setLoading(false);
  };
  const initTags = () => {
    getTags().then((r) => {
      const t = r.data.map((d) => ({ value: d.tag, label: d.tag }));
      setTags(t);
    });
  };
  React.useEffect(() => {
    initTags();
  }, []);
  return (
    <>
      <NavTop title="Edit Transaction" />
      <div className="main-padding">
        <form className="px-2" onSubmit={submit}>
          <div className="form-group">
            <label htmlFor="businessUnit">Wallet</label>
            <div
              className="form-control d-flex align-items-center justify-content-between"
              onClick={selectWallet}
            >
              <span>{walletSearch.name}</span>
              <IoIosArrowForward />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="amount">Amount</label>
            <NumberFormat
              id="amount"
              prefix={"Rp "}
              value={amount}
              className="form-control"
              thousandSeparator={true}
              onValueChange={(v) => setAmount(v.floatValue)}
            />
            <small id="amountHelp" className="d-none form-text text-muted">
              We'll never share your email with anyone else.
            </small>
          </div>
          <div className="form-group">
            <label htmlFor="date">Date</label>
            <input
              id="date"
              type="date"
              value={date}
              className="form-control"
              aria-describedby="dateHelp"
              onChange={(e) => setDate(e.target.value)}
            />
            <small id="dateHelp" className="d-none form-text text-muted">
              We'll never share your email with anyone else.
            </small>
          </div>
          <div className="form-group">
            <label htmlFor="amount">Description</label>
            <textarea
              id="description"
              value={description}
              className="form-control"
              aria-describedby="descriptionHelp"
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Tag</label>
            <CreatableSelect
              isMulti
              options={tags}
              defaultValue={selectedTags}
              onChange={handleSelectChange}
              className="basic-multi-select"
              classNamePrefix="select"
              placeholder="Select Tag"
            />
          </div>
          <FileUpload
            value={attachmentUrl}
            onChange={setAttachmentUrl}
            label="Lampiran (opsional)"
          />
          <small id="descriptionHelp" className="d-none form-text text-muted">
            We'll never share your email with anyone else.
          </small>
          {loading ? (
            <ButtonLoading />
          ) : (
            <button className="btn btn-block btn-primary mt-3">Simpan</button>
          )}
        </form>
      </div>
    </>
  );
};
